import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/planning-liv-icon.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "planning"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_spinner_facebook = _resolveComponent("q-spinner-facebook")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (!_ctx.connectedUser.isAudit && _ctx.order?.resourceUid && _ctx.checkUserByRole([_ctx.MenuRoles.ROLE_MENU_PLANNIG]) && _ctx.externalReference && _ctx.isDeliveryAppointmentStatusAllowed(_ctx.order.status.resourceUid))
    ? (_openBlock(), _createBlock(_component_q_btn, {
        key: 0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.viewDelivery())),
        flat: "",
        unelevated: "",
        dense: ""
      }, {
        loading: _withCtx(() => [
          _createVNode(_component_q_spinner_facebook)
        ]),
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_q_tooltip, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("demand.button.goToDelivery")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}